export default "__VITE_ASSET__e575f681__"